import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { NgIf } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { StateNotifyService } from '../../../../common/state/service/state-notify.service';
import { Subject, takeUntil } from 'rxjs';
import { Recommendation } from '../../dto/recommendation';
import { RecommendationService } from '../../service/recommendation.service';
import { RecommendationPropertiesService } from '../../service/recommendation-properties.service';
import { RecommendationType } from '../../dto/recommendation-type';
import { BoolDto } from '../../../../common/dto/bool-dto';
import { Test } from '../../../test/dto/test';
import { Router } from '@angular/router';

@Component({
  selector: 'dpi-test-recommendation',
  imports: [MatCardModule, MatTableModule, MatIconModule, MatButtonModule, MatToolbarModule, MatButtonToggleModule,
    MatTooltipModule, NgIf],
  templateUrl: './test-recommendation.component.html',
  styleUrl: './test-recommendation.component.scss'
})
export class TestRecommendationComponent implements OnInit, OnDestroy {
  displayedColumns: string[] = ['sn', 'description', 'type', 'closed'];
  dataSource: Recommendation[] = [];
  destroyed$ = new Subject<void>(); // notifier of component destroyed
  @Output('listSizeChanged') listSize = new EventEmitter<number>();
  isReadonly: boolean;

  recommendationType: RecommendationType[];
  closedStates: BoolDto[];

  constructor(private notifyService: StateNotifyService
    , private recommendationService: RecommendationService
    , private recommendationPropertiesService: RecommendationPropertiesService
    , private router: Router) {
    this.isReadonly = true;
    this.recommendationType = this.recommendationPropertiesService.getAllRecommendationTypes();
    this.closedStates = this.recommendationPropertiesService.getAllRecommendationClosedStates();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  ngOnInit(): void {
    this.notifyService.testSelection$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(model => {
        this.reload(model);
      });

    this.notifyService.readonlyMode$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(res => {
        this.onEditModeChange(res);
      });
  }

  reload(selectedTest: Test) {
    this.recommendationService.getAllRecommendationOfTest(selectedTest.id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (res: any) => {
          this.dataSource = res;
          this.notifyService.updateListAllRecommendation(this.dataSource);
          this.listSize.emit(this.dataSource.length);
          for (var rec of this.dataSource) {
            let rec_type = this.recommendationPropertiesService.getRecommendationType(this.recommendationType, rec.type);
            rec.type_text = rec_type.name;
            let rec_state = this.recommendationPropertiesService.getRecommendationClosedState(this.closedStates, rec.closed);
            rec.closed_text = rec_state.expression;
          }
        },
        error: (error: any) => {
          console.error('Error: ', error);
          this.dataSource = [];
        }
      })
  }

  onEditModeChange(isReadonly: boolean) {
    this.isReadonly = isReadonly;
  }

  selectRecommendation(selected: Recommendation) {
    this.notifyService.updateRecommendationSelection(selected);
    this.router.navigate(['recommendation-hub']);
  }

  createRecommendation() {
    let testModel = this.notifyService.getSelectedTest();
    this.recommendationService.createRecommendation(testModel.id)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: model => {
          this.dataSource.push(model);
          this.selectRecommendation(model);
        },
        error: err => { console.log(err); }
      });
  }

}
